import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'group-box';
var GroupBoxWrapper = aggregatedClasses('div')(blockName, 'wrapper', function (_ref) {
  var _ref2;

  var onlyHeader = _ref.onlyHeader,
      noBorder = _ref.noBorder,
      type = _ref.type,
      isMain = _ref.isMain;
  return _ref2 = {
    'only-header': onlyHeader,
    'no-border': noBorder
  }, _defineProperty(_ref2, type, type), _defineProperty(_ref2, 'main-box', isMain), _defineProperty(_ref2, 'nested-box', !isMain), _ref2;
});
var GroupBoxContent = aggregatedClasses('div')(blockName, 'content', function (_ref3) {
  var _ref4;

  var type = _ref3.type,
      asRow = _ref3.asRow,
      onlyHeader = _ref3.onlyHeader,
      noPadding = _ref3.noPadding,
      noBorder = _ref3.noBorder,
      noBorderTop = _ref3.noBorderTop;
  return _ref4 = {}, _defineProperty(_ref4, type, type), _defineProperty(_ref4, 'as-row', asRow), _defineProperty(_ref4, 'only-header', onlyHeader), _defineProperty(_ref4, 'no-padding', noPadding), _defineProperty(_ref4, 'no-border', noBorder), _defineProperty(_ref4, 'no-border-top', noBorderTop), _ref4;
});
var Label = aggregatedClasses('div')(blockName, 'label', function (_ref5) {
  var _ref6;

  var borderBottom = _ref5.borderBottom,
      type = _ref5.type,
      noBorder = _ref5.noBorder;
  return _ref6 = {
    'border-bottom': borderBottom
  }, _defineProperty(_ref6, type, type), _defineProperty(_ref6, 'no-border', noBorder), _ref6;
});

export { GroupBoxContent, GroupBoxWrapper, Label };
//# sourceMappingURL=blocks.js.map
